<template>
  <div>
    <div class="banner2">
      <el-image src="https://sritrang.oss-cn-shanghai.aliyuncs.com/202108/2021082912340689.jpg"></el-image>
      <div class="cover">
        <h1>业务介绍</h1>
        <div class="subtitle">绿色橡胶</div>
      </div>
    </div>
    <div class="img">
      <el-image fit="fill" src="/img/ywjs-bg1.jpg"></el-image>
      <div class="tp">
        <el-row>
          <el-col :span="12">
            <div class="img">
              <el-image src="/img/b10.png"></el-image>
            </div>
            <div class="desc">
              <h1 class="text-1">
                <span class="custom-font-color-1">“ </span>
                <span class="bg-2" style="color: rgb(255, 255, 255); padding: 5px 20px;">诗董</span>
              </h1>
              <h1 class="text-2">
                <span class="bg-3" style="color: rgb(255, 255, 255); padding: 5px 20px;">绿色橡胶的先行者</span>
                <span class="custom-font-color-2"> ” </span>
              </h1>
              <h1 class="text-3">
                诗董作为产业链集成的橡胶公司，以透明，公平的方式开展业务，生产优质，环保的产品，关心上游至下游供应链中的所有利益相关者。
              </h1>
            </div>
          </el-col>
          <el-col :span="12">

          </el-col>
        </el-row>
      </div>
    </div>

    <div class="c-box2">
      <el-row>
        <el-col :span="10">
          <el-image src="/img/b12.jpg"></el-image>
        </el-col>
        <el-col :span="14">
          <div class="c-d">
            <div class="t-1">
              诗董橡胶股份有限公司是全球领先的天然橡胶产业链集成公司，天然橡胶加工能力覆盖了泰国、印尼、缅甸三个国家，目前产品包括标胶（TSR），烟片（RSS）和浓缩乳胶，总产能达286万吨/年。诗董以高效、诚信、专业的产品和服务，为全球主要轮胎企业、橡胶制品企业源源不断地输送着高品质的绿色原材料。
            </div>
            <div class="t-3">诗董的“绿色橡胶”理念拥有丰富的内涵：</div>
            <div class="t-2"> 绿色的产品：</div>
            <div class="dd">提供清洁、安全的产品。</div>
            <div class="t-2">绿色的工厂：</div>
            <div class="dd">使用安全的能源，对废水肥料进行充分处理，确保生产设施与周边环境和居民和谐友好。</div>
            <div class="t-2">绿色的供应：</div>
            <div class="dd">与胶农和二盘商积极构建公平合理的采购体系，推动上游供应清洁优质的原材料。</div>
            <div class="t-2">绿色的企业：</div>
            <div class="dd">运营体系健康透明，推动行业的可持续发展。</div>
          </div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style scoped>
@import url("Index.css");
</style>